import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home.jsx'
import Contact from './pages/Contact'
import PrivacyPolicy from './pages/PrivacyPolicy'
import Disclaimer from './pages/Disclaimer'
import DynamicPage from './pages/DynamicPage'
import ContentDisplay from './pages/ContentDisplay'
import BlogListing from './pages/BlogListing'
import BlogDetail from './pages/BlogDetail'
import './App.css'

function ScrollToTop({ children }) {
  const { pathname } = useLocation()

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual"
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    })

    const timer = setTimeout(() => {
      if (window.scrollY !== 0) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "instant",
        })
      }
    }, 0)

    return () => clearTimeout(timer)
  }, [pathname])

  return children
}

function AppContent() {
  return (
    <ScrollToTop>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/blogs" element={<BlogListing />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/:pageSlug/:contentSlug" element={<ContentDisplay />} />
          <Route path="/:slug" element={<DynamicPage />} />
        </Routes>
        <Footer />
        
        {/* Floating WhatsApp Icon */}
        <div className="whatsapp-float">
          <a 
            href="https://whatsapp.com/channel/0029Vb78ck8KGGGQg9T32K16" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="whatsapp-float-btn"
            title="Join WhatsApp"
          >
            <i className="fab fa-whatsapp"></i>
          </a>
        </div>

        {/* Floating Instagram Icon */}
        <div className="instagram-float">
          <a 
            href="https://www.instagram.com/skillshiksha1?igsh=MW12NWRtdjAxdGN6eQ==" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="instagram-float-btn"
            title="Follow on Instagram"
          >
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </ScrollToTop>
  )
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  )
}

export default App

